export default __webpack_public_path__ + "static/media/gcash.19dc52cb.png";